import { PaymentSocketResponse } from "../types/payment";

export const getOrderStatusManual = (orderData: PaymentSocketResponse) => {
  // Placeholder for any manual order status check if needed
  if (orderData.code !== "000") return "failed";
  if (orderData.status === "success") return "success";

  if (orderData.status === "expired") return "expired";
  return "pending";
};
